module.exports = "<div class=\"row q-marg-vert-md recipient-row\"> <div class=col-xs-10> <input required class=\"q-input q-stretch schedule-modal-recipients-input\" type=text name=\"modalReportRecipientsInput{%-index%}\" placeholder=johnsmith@retailer1.com /> </div> <div class=\"col-xs-2 q-marg-vert-xxs q-text-center-at-md\"> <a href=# class=delete-recipient> <i class=\"fa fa-times\" aria-hidden=true></i> </a> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/report/lookup/html/recipient.html
// module id = 1402
// module chunks = 1